<template>
    <div class="mb-1">
        <v-row no-gutters>  
            <v-col cols="12" md="2" >
                <v-autocomplete
                    :label="$t('item')" 
                    v-model="line.item_id"
                    :rules="[isRequired]"
                    class="me-1" 
                    outlined 
                    :items="items"
                    item-value="id"
                    item-text="display_name"
                    dense 
                    hide-details="auto"
                    @update:search-input="$emit('update:item-search-input', $event)"
                    />
            </v-col>
            <v-col cols="12" md="1"  >
                <v-text-field
                    :label="$t('quantity')" 
                    v-model="line.quantity"
                    :rules="[isRequired, isNumeric]"
                    class="me-1" 
                    background-color="white" 
                    outlined 
                    dense 
                    hide-details="auto"
                    >
                </v-text-field>
            </v-col>
            <v-col cols="1">
                
                <v-autocomplete 
                    outlined
                    dense
                    hide-details="auto"
                    :items="measure_units"
                    item-text="name"
                    item-value="id"
                    label="Measure Unit"
                    class="me-1"
                    v-model="line.measure_unit_id"
                >

                </v-autocomplete>
            </v-col>
            <v-col cols="2">
                <v-text-field 
                    :label="$t('unit_value')" 
                    v-model="line.unit_value"
                    :rules="[isRequired, isNumeric]"
                    class="me-1"
                    background-color="white" 
                    outlined
                    dense 
                    hide-details="auto"
                    @change="handleUnitValueChange">
                </v-text-field>
            </v-col>
            <v-col cols="2">
                <v-text-field
                    :label="$t('total_value')" 
                    :value="total_value"
                    :rules="[isRequired, isNumeric]"
                    readonly
                    class="me-1" 
                    outlined 
                    dense 
                    background-color="white"
                    hide-details="auto">
                </v-text-field>
            </v-col>
            <v-col md="2">
                <v-autocomplete
                    :label="$t('account')" 
                    v-model="line.account_id"
                    :rules="[isRequired]"
                    class="me-1" 
                    background-color="white"
                    outlined
                    :items="userAccounts"
                    item-text="display_name"
                    item-value="id" 
                    dense 
                    hide-details="auto"
                    />
            </v-col> 
            <v-col cols="2" >
                <div class="d-flex align-center">

                    <v-autocomplete
                        :label="$t('dimension')" 
                        v-model="line.dimension_id"
                        background-color="white" 
                        outlined 
                        dense
                        :items="dimensions"
                        item-text="name"
                        item-value="id" 
                        hide-details="auto" 
                        ></v-autocomplete>
                        
                    <v-btn
                        icon
                    >
                        <v-icon @click="deleteRow">mdi-close</v-icon>
                    </v-btn>
                </div>
            </v-col>   
        </v-row>
    </div>
</template>

<script>
import { round } from 'lodash';
import { mapGetters } from 'vuex';

import { isRequired , isNumeric} from './../../utils/validations';
export default {
    components: {
    },
    props: {
        value: Object,
        items: Array
    },
    data() {
        return {
            isNumeric,
            isRequired,
            line: {...this.value},
            itemLoading: false
        }
    },
    computed: {
          ...mapGetters({
            // items: "stockJournal/item/items",
            userAccounts: "stockJournal/account/userAccounts",
            dimensions: "stockJournal/dimension/dimensions"
        }),
        total_value() {
            return this.line.quantity * this.line.unit_value
        },
        item() {
            return this.items.find(item => item.id == this.line.item_id)
        },
        measure_units() {
            return this.item ? this.item.measure_units : [] 
        },
        measure_unit() {
            return this.measure_units.find(mu => mu.id == this.line.measure_unit_id)
        },
        base_quantity() {
            return this.measure_unit ? this.line.quantity * this.measure_unit.conversion : null
        }
    },
     watch:{
        line: {
            handler(line){
                this.$emit('input', {...line, base_quantity: this.base_quantity, value: this.total_value});
            },
            deep: true
        },
        
    },
    methods: {
        deleteRow(){
            this.$emit('delete-row')
        },
        handleUnitValueChange() {
            this.calculateValue();
        },
        calculateValue() {
            if(isNaN(this.line.unit_value)) {
                this.line.value = null;
                return;
            }
            this.line.value = round(this.line.unit_value * this.line.quantity, 2);
        },
        
    },
    
}
</script>

<style>

</style>